import { connect, EasyField } from 'react-bootstrap-formutil';
import { CustomerInfoKeyType, HomeAddressTypeEnum } from 'types/customer';
import BaseAddress, { BaseAddressProps } from './BaseAddress';

export interface ChnHomeAddressProps extends Omit<BaseAddressProps, 'prefix'> {
    hasCountry?: boolean;
    legalResidenceCountry?: string;
}

export const getChnHomeAddressFields = (needHomeAddressType: boolean = true) => {
    const baseFields: CustomerInfoKeyType[] = [
        'home_state',
        'home_city',
        'home_district',
        'home_detail',
        'has_delivery_address',
        'same_delivery_and_residence'
    ];

    return needHomeAddressType ? baseFields.concat('home_address_type') : baseFields;
};

const ChnHomeAddress: React.FC<ChnHomeAddressProps> = ({ legalResidenceCountry, hasCountry, ...restProps }) => {
    return (
        <div className="chn-home-address-root">
            <BaseAddress prefix="home" {...restProps} />
            {hasCountry && <EasyField type="hidden" name="home_country" $defaultValue={legalResidenceCountry} />}
            <EasyField name="home_address_type" type="hidden" $defaultValue={HomeAddressTypeEnum.CHN} />
        </div>
    );
};

export default connect(ChnHomeAddress);
